export default function Logo() {
  return (
    <>
      <img src='img/Icon.png' alt='Sacola de compras' />
    </>
  );
}